// EXAMPLE / TEST DATA — NOT REAL PII — DEMO ONLY
// ─────────────────────────────────────────────────────────────────────────────
// DEMO: Tilin yhdistäminen (prototyyppidemo — poista testin jälkeen)
//
// Tämä moduuli sisältää KOKO "Tilin yhdistäminen" -demon yhdessä paikassa:
//   • muistinvarainen demodata: yhdistämistukipyyntö + uusi (vajaa) lähdetili +
//     vanha (lepäävä) kohdetili. Nollautuu sivun uudelleenlatauksessa →
//     toistettava käytettävyystesti (ei localStoragea, CLAUDE.md).
//   • RTK-cache-kääre (demoWrapBaseQuery): injektoi demoentiteetit joka
//     pyynnöllä listoihin ja lyhytsulkee demo-ID:t. EI kirjoita oikeaan
//     Trivore/Firestore-backendiin — kaikki tapahtuu selaimen muistissa.
//   • yhdistämislogiikka (mergeDemoAccounts) + tukipyynnön ratkaisu.
//
// POISTO testin jälkeen: poista tämä kansio (src/demo/) + backendApi.ts:n
// DEMO-merkatut kohdat (baseQuery-kääre + mergeAccounts-endpoint). Ei muuta.
// (Poikkeus: AuditTyyppi/AuditTrail-komponentin "tili_yhdistetty" on oikeaa
//  ominaisuuskoodia, ei demoa — se jää.)
// ─────────────────────────────────────────────────────────────────────────────

import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { Kayttaja, Tukipyynto } from "../types";
// DEMO/ESIKATSELU: poistettu-käyttäjän merkinnän ulkoasun näyttäminen.
import { esikatseluPoistettu } from "./poistettuEsikatselu";

export const MERGE_AIHE = "Tilin yhdistäminen";

export type MergeArgs = {
  sourceUid: string;
  targetUid: string;
  vastaus: string;
  virkailijaUid: string;
  virkailijaNimi: string;
  tikettinumero: string;
};

type DemoBaseQuery = ReturnType<typeof fetchBaseQuery>;
